import { types } from './types';

export const setPhotoLogUploadingStateTo = (isUploadingPhotoLog) => dispatch => {
    if (isUploadingPhotoLog) {
        console.log('%cShow Upload Spinner Action Dispatching!', 'color: greenyellow');

        
        dispatch({
            type: types.UPLOADING_PHOTO_LOG_STARTED
        })
    } else {
        console.log('%cHide Upload Spinner Action Dispatching!', 'color: greenyellow');
        dispatch({
            type: types.UPLOADING_PHOTO_LOG_COMPLETED
        })
    }
}


// WEBPACK FOOTER //
// ./src/js/actions/photo-log-actions.js